import { cacheDecorator } from '@ds/swymkit/tools'

import { swymFetch } from '~/services/fetch-swym'

import { _userParser } from '~/entities/user/user/api/parser-users'
import { getUser } from '~/entities/user/user/api/users'

import type { NetworkInvitation, ReceivedInvitation } from '~/features-swym/network-activity/interfaces/network-activity'
import { EInvitationAcceptStatus } from '~/features-swym/network-activity/interfaces/network-activity'

import type { SwymResponse } from '~/interfaces/services-dto'

interface IInvitationParams {
  id: string
  status?: EInvitationAcceptStatus
}

export function getInvitations(hash_key: string) {
  return cacheDecorator('network-invitations', async () => {
    const response = await swymFetch
      .post('/api/network/getpendingrequests', {
        json: {
          params: {
            hash_key,
          },
        },
      })
      .json<SwymResponse<NetworkInvitation[]>>()

    const result: ReceivedInvitation[] = []
    for (const item of response.result) {
      const sender = _userParser((await getUser(item.hash_key)).result)
      result.push({ ...item, sender, date: item.dateC })
    }

    return result
  }, 5000)
}

export function acceptInvitation(params: IInvitationParams) {
  return swymFetch
    .post('/api/network/updaterequestsnetwork', {
      json: {
        params: {
          notification_id: params.id,
          group_id: null,
          accept_status: params.status,
        },
      },
    })
}

export function declineInvitation(params: IInvitationParams) {
  return swymFetch
    .post('/api/network/updaterequestsnetwork', {
      json: {
        params: {
          notification_id: params.id,
          group_id: null,
          accept_status: EInvitationAcceptStatus.Decline,
        },
      },
    })
}
